import {
  DumbStorageValue,
  type DumbStorageValueConfig,
} from "./dumb-local-storage";
import { notifySubject, SimpleObservableSubject } from "./observable";

export class ObservableDumbStorageValue<T> extends DumbStorageValue<T> {
  subject: SimpleObservableSubject<T>;

  constructor(
    key: string,
    defaultValue: T,
    options: Omit<DumbStorageValueConfig<T>, "key" | "defaultValue">,
  ) {
    super({ key, defaultValue, ...options });
    this.subject = new SimpleObservableSubject<T>({
      onlyNotifyOnChanges: true,
    });
  }

  protected notify(data: T) {
    notifySubject(this.subject, data);
  }

  set(value: T): void {
    super.set(value);
    this.notify(value);
  }

  remove(): void {
    super.remove();
    this.notify(this.defaultValue);
  }

  get(): T {
    const value = super.get();
    this.notify(value);
    return value;
  }
}
